export const ATTR_NEXT_SPAN_TYPE = 'next.span_type';
export const ATTR_NEXT_SPAN_NAME = 'next.span_name';
export const ATTR_NEXT_ROUTE = 'next.route';
export const ATTR_NEXT_SPAN_DESCRIPTION = 'next.span_description';
export const ATTR_NEXT_SEGMENT = 'next.segment';
